module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('form-group', {
    attrs: {
      "theme": _vm.theme,
      "size": "lg",
      "name": "testform"
    },
    on: {
      "on-submit": _vm.submit
    }
  }, [_c('form-input', {
    attrs: {
      "label": "手机号",
      "holder": "Phone",
      "format": "phone",
      "required": true,
      "for": "testform",
      "name": "phone"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "focus": "",
      "label": "邮 箱",
      "holder": "输入邮箱",
      "format": "email",
      "required": true,
      "for": "testform",
      "name": "email"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "小 数",
      "holder": "输入小数",
      "format": "float",
      "required": true,
      "for": "testform",
      "name": "float"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "整 数",
      "holder": "输入整数",
      "format": "int",
      "required": true,
      "for": "testform",
      "name": "int"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "模拟下拉",
      "holder": "",
      "format": "int",
      "required": true,
      "name": "boselect",
      "icon": "people",
      "enable": false
    },
    on: {
      "on-click": _vm.openDrawer
    }
  }), _vm._v(" "), _c('bo-select', {
    attrs: {
      "label": "原生下拉",
      "for": "testform",
      "name": "select",
      "value": "1",
      "required": true,
      "options": [{
        text: 'Item 1',
        value: 1
      }, {
        text: 'Item 2',
        value: 2
      }]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p2222"
  }, [_c('btn', {
    attrs: {
      "theme": "primary",
      "block": true,
      "size": "lg",
      "submit": "testform",
      "name": "确 认"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p2222"
  }, [_c('btn', {
    attrs: {
      "theme": "",
      "block": true,
      "size": "lg",
      "name": "切换风格"
    },
    on: {
      "on-click": _vm.changeTheme
    }
  })], 1), _vm._v(" "), _c('drawer', {
    attrs: {
      "show": _vm.showDrawer,
      "position": "center"
    }
  }, [_c('selector', {
    attrs: {
      "size": "lg",
      "underline": "true"
    },
    model: {
      value: (_vm.sval),
      callback: function($$v) {
        _vm.sval = $$v
      },
      expression: "sval"
    }
  }, [_c('selector-item', {
    attrs: {
      "text": "Item 1",
      "value": "1"
    }
  }), _vm._v(" "), _c('selector-item', {
    attrs: {
      "text": "Item 2",
      "value": "2"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10e2dc62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-group/demo.vue
// module id = 223
// module chunks = 1